import React from "react"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import { graphql, useStaticQuery } from "gatsby"
import { analyticsAction } from "../utils/analytics"
import { useTranslation } from "react-i18next"

const logosList = [
  {
    link: "https://www.aicpa-cima.com/topic/audit-assurance/audit-and-assurance-greater-than-soc-2",
    imageName: "soc-2.png",
    alt: "SOC-2",
  },
  {
    link: "https://www.ttpn.org/",
    imageName: "TPN_Blue_Badge.png",
    alt: "TPN - Trusted Partner Network",
  },
  {
    link: "https://auth0.com/",
    imageName: "auth0+okta.png",
    alt: "Auth0 and Okta",
  },
]

function ProcessSecurity() {
  const { t } = useTranslation("home")

  const data = useStaticQuery(graphql`
    query {
      allFile(filter: { sourceInstanceName: { eq: "images" } }) {
        edges {
          node {
            relativePath
            childImageSharp {
              gatsbyImageData(width: 300, quality: 80, layout: FULL_WIDTH)
            }
          }
        }
      }
    }
  `)

  const getImageByName = name => {
    const imageNode = data.allFile.edges.find(
      edge => edge.node.relativePath === `film/certifications/${name}`,
    )
    return imageNode ? getImage(imageNode.node.childImageSharp) : null
  }

  return (
    <section>
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="py-12 md:py-20 border-t border-gray-800">
          {/* Section header */}
          <div className="max-w-3xl mx-auto text-center pb-12 md:pb-20">
            <h2 className="h2 mb-4" data-aos="fade-up">
              {t("security.title")}
            </h2>
            <div
              className="inline-flex text-lg font-semibold py-1 px-3 m-2 text-green-700 bg-green-200 rounded-full mb-4"
              data-aos="fade-up"
              data-aos-delay="200"
            >
              {t("security.badge")}
            </div>
            <p
              className="text-xl text-gray-400"
              data-aos="fade-up"
              data-aos-delay="400"
            >
              {t("security.description")}
            </p>
          </div>

          <div
            className={`grid gap-1 grid-cols-1 md:grid-cols-3`}
            data-aos-id-clients
          >
            {logosList.map((partner, index) => {
              const image = getImageByName(partner.imageName)
              const delay = 100 * (index + 1)
              return (
                <a
                  key={index}
                  href={partner.link || "#"}
                  target="_blank"
                  rel="nofollow"
                  className="flex items-center justify-center h-32  border-gray-700 p-2"
                  data-aos="fade-up"
                  data-aos-anchor="[data-aos-id-clients]"
                  data-aos-delay={delay}
                >
                  {image && (
                    <div className="h-full w-full px-5 md:px-2 md:py-1 hover:opacity-100 opacity-80 transition duration-300 ease-in-out">
                      <GatsbyImage
                        image={image}
                        alt={partner.alt}
                        className="h-full w-full"
                        imgStyle={{ objectFit: "contain" }}
                      />
                    </div>
                  )}
                </a>
              )
            })}
          </div>

          {/* CTA button */}
          <div
            className="flex justify-center mt-12"
            data-aos="fade-up"
            data-aos-delay="200"
            data-aos-anchor="[data-aos-id-cta]"
          >
            <a
              className="btn text-gray-800 bg-fOrange-900 hover:bg-fOrange-800"
              href="https://help.filmustage.com/en/articles/5543878-filmustage-security"
              target="_blank"
              onClick={async () =>
                await analyticsAction("landing_security_click")
              }
            >
              {t("security.button")}
            </a>
          </div>
        </div>
      </div>
    </section>
  )
}

export default ProcessSecurity
